class Cart extends HTMLElement {
  constructor() {
    super();
    this.handleQuantityFields();
    this.handleAddToCart();
    this.handleAddAllToCart();
  }

  handleQuantityFields() {
    document.body.addEventListener('click', (event) => {
      const target = event.target.closest('.js-change-quantity');
      if (!target) return;

      event.preventDefault();
  
      target.classList.add('loading');
        
      const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
      let quantity = parseInt(target.getAttribute('data-quantity'), 10);
      const container = target.closest('.js-cart-item').querySelector('.js-quantity-fields');
      const max = parseInt(target.getAttribute('max'), 10);

      if (!isNaN(max) && quantity > max) {
        alert(window.cartStrings.quantityError.replace('[quantity]', max));
        target.classList.remove('loading');
        return;
      }

      const item = target.closest('.js-cart-item');
      item?.querySelector('.js-quantity-minus')?.setAttribute('data-quantity', quantity - 1);
      item?.querySelector('.js-quantity-plus')?.setAttribute('data-quantity', quantity + 1);

      const syncedItems = document.querySelectorAll(`.js-cart-item[data-variant-id="${variantId}"]`);

      const cartItem = container.closest('.js-cart-item');
      cartItem.style.height = `${cartItem.offsetHeight}px`;
        
      var formData = new FormData();
      formData.append("updates[" + variantId + "]", quantity);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
        document.querySelectorAll('.js-subtotal-price').forEach(el => {
          el.innerHTML = Shopify.formatMoney(response.total_price);
        });
        
        if (quantity < 1) {
          syncedItems.forEach(it => {
            it.classList.add('hide-item');
            setTimeout(() => {
              it.classList.add('hidden');
              if (response.total_price === 0) {
                document.querySelectorAll('.js-canvas-cart, .js-header-cart').forEach(cartRoot => {
                  cartRoot.classList.add('canvas-cart__empty');
                });
              }
            }, 300);
          });
        } else {
          container.querySelector('.js-quantity-field-input').value = quantity;          
          syncedItems.forEach(it => {
            const qtyEl = it.querySelector('.js-item-quantity');
            if (qtyEl) qtyEl.innerHTML = quantity;
          });
        }

        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = response.item_count;
          cartCounter.setAttribute('data-counter', response.item_count);
        });
      })
      .catch(error => {
        alert(error.message || 'Error');
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
      });
    });
  }

  handleAddToCart() {
    document.body.addEventListener("click", function (event) {
      const target = event.target.closest(".js-add-to-cart");
      if (!target) return;

      event.preventDefault();

      target.getAttribute("data-adding-text") && (target.innerHTML = target.getAttribute("data-adding-text"));
      target.classList.add("loading");

      let quantity, id, sellingPlanId, properties = {};

      let productId = target.getAttribute("data-product-id");
      let productElement = document.querySelector(`.js-product[data-product-id='${productId}']`);
      quantity = productElement?.querySelector(".js-quantity-field")?.value || 1;
      if (isNaN(quantity) || !quantity) quantity = 1;
      if (target.hasAttribute("data-variant-id")) {
        id = target.getAttribute("data-variant-id");
      } else {
        id = productElement ? productElement.querySelector(`#product-select-${productId}`).value : null;
      }

      const max = productElement?.querySelector(`#product-select-${productId}`)?.selectedOptions[0]?.dataset.max || null;

      sellingPlanId = productElement?.querySelector("input[name='selling_plan']")?.value || null;

      let image = target.getAttribute("data-featured-image");

      const propertyInputs = productElement?.querySelectorAll("[name^='properties[']") || [];
      propertyInputs.forEach(input => {
        const nameMatch = input.name.match(/properties\[(.+?)\]/);
        if (nameMatch && input.value) {
          properties[nameMatch[1]] = input.value;
        }
      });

      let formData = {
       'items': [{
          'id': parseInt(id, 10),
          'quantity': parseInt(quantity, 10),
          ...(Object.keys(properties).length && { properties }),
          ...(sellingPlanId && { selling_plan: sellingPlanId })
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response = response.items.find(item => item.id === parseInt(id, 10));
        let variantId = response.variant_id;
        let cartItem = document.querySelector(`.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`);

        if (cartItem) {
          let quantityPrice = cartItem.querySelector(".js-item-quantity");
          let quantityField = cartItem.querySelector(".js-quantity-field-input");
          let quantityMinus = cartItem.querySelector(".js-quantity-minus");
          let quantityPlus = cartItem.querySelector(".js-quantity-plus");

          if(quantityPrice) quantityPrice.innerHTML = response.quantity;
          quantityField.value = response.quantity;
          quantityMinus.setAttribute("data-quantity", response.quantity - 1);
          quantityPlus.setAttribute("data-quantity", response.quantity + 1);
        } else {
          let quantityMinus = response.quantity - 1;
          let quantityPlus = response.quantity + 1;

          let discountsHtml = '';
          if (
            response.line_level_discount_allocations &&
            response.line_level_discount_allocations.length > 0
          ) {
            response.line_level_discount_allocations.forEach(discount => {
              discountsHtml += `
                <span class="cart-item__discount">
                  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.94629 2.5L3.18555 6.26074L5.90918 8.9834L9.67188 5.22461V2.5H6.94629Z" stroke="#000" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                  ${discount.discount_application.title}
                </span>`;
            });
          }

          let unitPriceHtml = '';
          if (
            response.unit_price &&
            response.unit_price_measurement &&
            response.unit_price_measurement.reference_value &&
            response.unit_price_measurement.reference_unit
          ) {
            unitPriceHtml = `
              <span class="cart-item__unit-price">
                ${Shopify.formatMoney(response.unit_price)} /
                ${response.unit_price_measurement.reference_value}
                ${response.unit_price_measurement.reference_unit}
              </span>`;
          }
          let item = `
          <li class="cart-item d-flex js-cart-item" data-variant-id="${response.variant_id}">
            <p class="cart-item__image">
              <a href="${response.url}">
                <img
                  alt="${response.product_title}"
                  src="${image || response.image || ''}"
                />
              </a>
            </p>

            <p class="cart-item__details">
              <a href="${response.url}" class="cart-item__title">${response.product_title}</a>
              ${response.variant_title && response.variant_title !== 'Default Title'
                ? `<span class="cart-item__variant">${response.variant_title}</span>`
                : ''}
              ${response.selling_plan_allocation && response.selling_plan_allocation.selling_plan ? `<div class="cart-item__subscription">${response.selling_plan_allocation.selling_plan.name}</div>` : ''}
              ${response.properties ? Object.entries(response.properties)
                .filter(([key, value]) => value && key[0] !== '_')
                .map(([key, value]) => {
                  if (typeof value === 'string' && value.includes('/uploads/')) {
                    return `<div class="cart-item__variant">${key}: <a href="${value}" class="link" target="_blank">${value.split('/').pop()}</a></div>`;
                  } else {
                    return `<div class="cart-item__variant">${key}: ${value}</div>`;
                  }
                }).join('') : ''}
              <span class="cart-ietm__price">
                <u class="js-item-quantity">${response.quantity}</u> <i>x</i> ${Shopify.formatMoney(response.final_price)}
              </span>
              ${unitPriceHtml}
              ${discountsHtml}
            </p>

            <div class="cart-item__quantity js-quantity-fields">
              <div class="cart-product__quantity-field">
                <div class="quantity-field__minus">
                  <a href="#" class="js-change-quantity js-quantity-minus"
                    max="${max}"
                     data-variant-id="${response.variant_id}"
                     data-quantity="${response.quantity - 1}">-</a>
                </div>
                <input type="text" value="${response.quantity}"
                       class="quantity-field__input js-quantity-field-input" disabled="disabled" />
                <div class="quantity-field__plus">
                  <a href="#" class="js-change-quantity js-quantity-plus"
                    max="${max}"
                     data-variant-id="${response.variant_id}"
                     data-quantity="${response.quantity + 1}">+</a>
                </div>
              </div>
            </div>

            <p class="cart-item__delete">
              <a href="#" class="js-change-quantity"
                 data-variant-id="${response.variant_id}"
                 data-quantity="0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lnil lnil-close" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></a>
            </p>
          </li>`;

          document.querySelectorAll(".js-cart-items").forEach(list => {
            list.insertAdjacentHTML("beforeend", item);
          });

          if (typeof initializeFadeInObserver === "function") {
            initializeFadeInObserver();
          }
        }

        return fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
      })
      .then(cart => {
        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
        document.querySelectorAll('.js-subtotal-price').forEach(el => {
          el.innerHTML = Shopify.formatMoney(cart.total_price);
        });

        document.querySelector(".js-canvas-cart")?.classList.remove("canvas-cart__empty");
        document.querySelector(".js-header-cart")?.classList.remove("canvas-cart__empty");
        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = cart.item_count;
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelector('.js-canvas-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-canvas-cart')?.classList.add('show');
        }, 50);
        document.body.style.overflow = 'hidden';
        document.querySelectorAll('.js-add-to-cart').forEach(button => {
          const originalText = button.getAttribute('data-original-text');
          if (originalText) {
            button.textContent = originalText;
          }
        });

        const quickViewElement = document.querySelector(".js-quickview");
        if (quickViewElement) {
          quickViewElement.classList.add("closing");
          setTimeout(function () {
            quickViewElement.classList.remove("active", "closing", "display");
            document.body.style.overflow = 'visible';
          }, 300);
        }
      })
      .catch(async (error) => {
        let message = 'Unexpected error';

        try {
          const text = await error.text();
          const json = JSON.parse(text);
          if (json && json.description) {
            message = json.description;
          }
        } catch (e) {
          message = error.message || 'Something went wrong';
        }

        alert(message);
        window.location.reload();
      });
    });
  }

  handleAddAllToCart() {
    document.body.addEventListener("click", (event) => {
      const btn = event.target.closest(".js-add-all-to-cart");
      if (!btn) return;

      event.preventDefault();

      if (btn.getAttribute("data-adding-text")) {
        btn.textContent = btn.getAttribute("data-adding-text");
      }

      const items = [];
      document.querySelectorAll(".js-frequently-bought-together-product").forEach((el) => {
        if (el.checked) {
          items.push({
            id: parseInt(el.getAttribute("data-variant-id"), 10),
            quantity: 1
          });
        }
      });

      if (!items.length) {
        alert("Choose minimum one product");
        btn.textContent = btn.getAttribute("data-original-text") || btn.textContent;
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      })
        .then((res) => {
          if (!res.ok) return res.json().then((err) => Promise.reject(err));
          return res.json();
        })
        .then((response) => {
          response.items.forEach((product) => {
            const variantId = product.variant_id;
            const existingItem = document.querySelector(`.js-cart-item[data-variant-id="${variantId}"]:not(.hidden)`);

            if (existingItem) {
              existingItem.querySelector(".js-quantity-minus")?.setAttribute("data-quantity", product.quantity - 1);
              existingItem.querySelector(".js-quantity-plus")?.setAttribute("data-quantity", product.quantity + 1);
              existingItem.querySelector(".js-quantity-field-input").value = product.quantity;
              existingItem.querySelector(".js-item-quantity").textContent = product.quantity;
            } else {
              const quantityMinus = product.quantity - 1;
              const quantityPlus = product.quantity + 1;
              const itemHTML = `
                <li class="cart-item d-flex js-cart-item" data-variant-id="${variantId}">
                  <p class="cart-item__image">
                    <a href="${product.url}">
                      <img alt="${product.product_title}" src="${product.image || ''}">
                    </a>
                  </p>
                  <p class="cart-item__details">
                    <a href="${product.url}" class="cart-item__title">${product.product_title+12}</a>
                    ${product.variant_title && product.variant_title !== "Default Title" ? `<span class="cart-item__variant">${product.variant_title}</span>` : ""}
                    <span class="cart-ietm__price">
                      <u class="js-item-quantity">${product.quantity}</u> <i>x</i> ${Shopify.formatMoney(product.price)}
                    </span>
                  </p>
                  <div class="cart-item__quantity js-quantity-fields">
                    <div class="cart-product__quantity-field">
                      <div class="quantity-field__minus">
                        <a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="${variantId}" data-quantity="${quantityMinus}">-</a>
                      </div>
                      <input type="text" value="${product.quantity}" class="quantity-field__input js-quantity-field-input" disabled="disabled" />
                      <div class="quantity-field__plus">
                        <a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="${variantId}" data-quantity="${quantityPlus}">+</a>
                      </div>
                    </div>
                  </div>
                  <p class="cart-item__delete">
                    <a href="#" class="js-change-quantity"
                       data-variant-id="${variantId}"
                       data-quantity="0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lnil lnil-close" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></a>
                  </p>
                </li>
              `;
              document.querySelectorAll(".js-cart-items").forEach((list) => {
                list.insertAdjacentHTML("beforeend", itemHTML);
              });
            }
          });

          return fetch("/cart.js").then((res) => res.json());
        })
        .then((cart) => {
          document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
          document.querySelectorAll('.js-subtotal-price').forEach(el => {
            el.innerHTML = Shopify.formatMoney(cart.total_price);
          });

          document.querySelector(".js-canvas-cart")?.classList.remove("canvas-cart__empty");
          document.querySelector(".js-header-cart")?.classList.remove("canvas-cart__empty");
          document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
            cartCounter.innerHTML = cart.item_count;
            cartCounter.setAttribute('data-counter', cart.item_count);
          });
          document.querySelector('.js-canvas-cart')?.classList.add('display');
          setTimeout(() => {
            document.querySelector('.js-canvas-cart')?.classList.add('show');
          }, 50);
          document.body.style.overflow = 'hidden';
          document.querySelectorAll('.js-add-all-to-cart').forEach(button => {
            const originalText = button.getAttribute('data-original-text');
            if (originalText) {
              button.textContent = originalText;
            }
          });

          const quickViewElement = document.querySelector(".js-quickview");
          if (quickViewElement) {
            quickViewElement.classList.add("closing");
            setTimeout(function () {
              quickViewElement.classList.remove("active", "closing", "display");
              document.body.style.overflow = 'visible';
            }, 300);
          }
        })
        .catch((err) => {
          alert(err.description || "Error while adding...");
          btn.textContent = btn.getAttribute("data-original-text") || btn.textContent;
        });
    });
  }
}

customElements.define('drawer-cart', Cart);